import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import moment from "moment";
import Typography from "@mui/material/Typography";
import { MealItems_Grid } from "./MealItems_Grid";
import { MealProducts_Grid } from "./MealProducts_Grid";
import { createKey } from "../../../../Shared/utils/createKey";
/**
 *
 * @param param0
 * @returns
 */
export const MealType_Details = ({ mappedMeal }) => {
    var _a, _b;
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Typography, Object.assign({ variant: "h3" }, { children: moment(mappedMeal.day).format("ddd MMM D") })) })), (_a = mappedMeal === null || mappedMeal === void 0 ? void 0 : mappedMeal.meals) === null || _a === void 0 ? void 0 : _a.map((meal) => (_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(MealItems_Grid, { meal: meal }) }), createKey()))), !!((_b = mappedMeal === null || mappedMeal === void 0 ? void 0 : mappedMeal.orderInfoProducts) === null || _b === void 0 ? void 0 : _b.products) && (_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(MealProducts_Grid, { products: mappedMeal.orderInfoProducts.products, showDate: false, mealDay: mappedMeal.orderInfoProducts.mealDay }) }), createKey()))] })));
};
